// extracted by mini-css-extract-plugin
export var chevron = "_32-2";
export var chevronCollapsed = "_32-3";
export var collapsibleHeader = "_32-1";
export var container = "_32-0";